import { createSlice } from "@reduxjs/toolkit";
import { updateAiCampaignAPI } from "../../services/updateAiCampaign";
import { updateAiCampaignStatusAPI } from "../../services/updateAiCampaignStatus";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const restartAiCampaignSlice = createSlice({
  name: "restartAiCampaign",
  initialState,
  reducers: {
    restartPending(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    restartSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "Campaign restarted successfully";
      state.error = "";
    },
    restartFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
    },
    restartReset(state) {
      state.isLoading = false;
      state.error = "";
      state.message = "";
      state.data = null;
    },
  },
});

export const restartAiCampaignHandler =
  ({ updatePayload, statusPayload }) =>
  async (dispatch) => {
    try {
      dispatch(restartAiCampaignAction.restartPending());
      const updateRes = await updateAiCampaignAPI(updatePayload);
      const statusRes = await updateAiCampaignStatusAPI(statusPayload);
      dispatch(
        restartAiCampaignAction.restartSuccess({
          update: updateRes,
          status: statusRes,
        }),
      );
    } catch (e) {
      dispatch(
        restartAiCampaignAction.restartFailure(
          e?.response?.data?.message || e?.message || String(e),
        ),
      );
    }
  };

export default restartAiCampaignSlice.reducer;
export const restartAiCampaignAction = restartAiCampaignSlice.actions;
